class ComponentDiplomaValidation extends HTMLDivElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initialize()
  }

  initialize() {
    if (this.initialized) {
      return
    }
    this.initialized = true

    this.inputElement = this.querySelector('.component-diploma-validation__input')
    this.submitElement = this.querySelector('.component-diploma-validation__submit')
    this.resultElement = this.querySelector('.component-diploma-validation__result')

    if (this.submitElement) {
      this.submitElement.addEventListener('click', this.submitHandler)
    }
    if (this.inputElement) {
      this.inputElement.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          // This markup is not a real <form> (see template comment), so
          // there is no native submit event - handle Enter explicitly and
          // stop it from bubbling to an ancestor form (e.g. the node-edit
          // form when this renders inside the Layout Paragraphs preview).
          event.preventDefault()
          this.submitHandler(event)
        }
      })
    }
  }

  submitHandler = async event => {
    event.preventDefault()

    const cedid = this.inputElement.value.trim()
    if (!cedid) {
      return false
    }

    const originalSubmitText = this.submitElement.textContent
    this.submitElement.disabled = true
    this.submitElement.textContent = 'Validating...'
    this.resultElement.innerHTML = ''

    try {
      const response = await fetch(
        `/diploma-validation/validate?cedid=${encodeURIComponent(cedid)}`,
        { headers: { Accept: 'application/json' } }
      )
      const result = await response.json()
      this.renderResult(result)
    } catch (error) {
      this.renderResult({
        valid: false,
        message:
          'We cannot validate the credential at this time. The information provided does not match the information on record, or there was a connection error. Please contact registrar@ucdenver.edu (Denver) or registrar@cuanschutz.edu (Anschutz) for assistance. When you do, please provide the student name and CeDiD to inquire further.'
      })
    } finally {
      this.submitElement.disabled = false
      this.submitElement.textContent = originalSubmitText
    }

    return false
  }

  renderResult(result) {
    if (!result || !result.valid) {
      this.resultElement.innerHTML = `
        <div class="component-diploma-validation__alert" role="alert">
          <p>${this.escapeHtml(result && result.message ? result.message : 'We cannot validate the credential at this time.')}</p>
        </div>
      `
      return
    }

    const rows = [
      ['CeDiD', result.credential_id],
      ['Name', result.name],
      ['Conferral Date', result.conferral_date],
      ['Credential', result.degree],
      ['School', result.school_name],
      ['Major', result.major],
      ['Honor', result.honor]
    ]

    const rowsHtml = rows
      .filter(([, value]) => value)
      .map(
        ([label, value]) =>
          `<tr><td><strong>${this.escapeHtml(label)}:</strong></td><td>${this.escapeHtml(value)}</td></tr>`
      )
      .join('')

    const scholarRecordHtml = result.hosted_validation_url
      ? `
        <a class="component-diploma-validation__scholar-record" href="${this.escapeHtml(result.hosted_validation_url)}" target="_blank" rel="noopener">
          <strong>Scholar</strong>Record
        </a>
        <p class="component-diploma-validation__scholar-record-note">
          By selecting ScholarRecord&trade;, you will be taken to CeCredential Trust, a trusted partner of the University, to provide you with more detail of the learner&rsquo;s credential.
        </p>
      `
      : ''

    // Paradigm's validation API doesn't return a validation timestamp, but
    // requires one be displayed for an audit trail (date/time/timezone),
    // so it's generated here at the moment the result is received.
    const validatedAt = new Date().toUTCString()

    this.resultElement.innerHTML = `
      <p><strong>This is a valid credential</strong></p>
      <p class="component-diploma-validation__timestamp">Validated: ${this.escapeHtml(validatedAt)}</p>
      <table class="component-diploma-validation__result-table">
        <tbody>${rowsHtml}</tbody>
      </table>
      ${scholarRecordHtml}
    `
  }

  escapeHtml(value) {
    const div = document.createElement('div')
    div.textContent = value == null ? '' : String(value)
    return div.innerHTML
  }
}

customElements.define('component-diploma-validation', ComponentDiplomaValidation, {
  extends: 'div'
})
